import { render } from "./SearchModal.vue?vue&type=template&id=1b25c650&scoped=true"
import script from "./SearchModal.vue?vue&type=script&lang=js"
export * from "./SearchModal.vue?vue&type=script&lang=js"

import "./SearchModal.vue?vue&type=style&index=0&id=1b25c650&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b25c650"]])

export default __exports__